<table class="table table-striped">
  <thead class="primary-color text-white">
    <tr>
      <th class="w-25">Title</th>
      <th class="w-25">Description</th>
      <th>Tags</th>
      <th>Author</th>
      <th>Actions</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let asset of Assets">
      <td>{{asset.title}}</td>
      <td>{{asset.description}}</td>
      <td><span *ngIf="asset.tags?.length > 0">{{asset.tags.join(", ")}}</span></td>
      <td>{{asset.originalCreator}}</td>
      <td>
        <button aria-label="View" class="btn btn-primary btn-sm" type="button" tabindex="0" (click)="viewAsset(asset)">
          <span aria-hidden="true" class="fa fa-eye"></span>
        </button>
      </td>
    </tr>
  </tbody>
</table>


// WEBPACK FOOTER //
// ./src/app/library-assets/asset-list/asset-list.component.html